module.exports = __webpack_public_path__ + "img/driven_poster_thumb.6ba7fdd6.jpg";